import React, { useState, useRef } from "react";
import SectionHeading from "../UIComponents/SectionHeading";
import Card from "../UIComponents/Card";
import ImageCard from "../UIComponents/ImageCard";

const tabs = ["Website", "Brand Content", "Logos"];

const WorkSection = () => {
    const [activeTab, setActiveTab] = useState("Website");
    const sectionRef = useRef(null);

    const websiteData = [
        {
            title: "E-commerce Website Development",
            description: "Harringtons Roses – Custom e-commerce website",
            image: "/Assets/harringtonsroses.co.uk.webp",
            src: "https://harringtonsroses.co.uk/",
        },
        {
            title: "E-commerce Website Development",
            description: "Titan Coatings – Industrial coatings website",
            image: "/Assets/titancoatings.us.webp",
            src: "https://titancoatings.us/",
        },
        {
            title: "Educational Website",
            description: "Edu Tank – Tutor and learning platform",
            image: "/Assets/edutank.in.webp",
            src: "https://edutank.in/",
        },
    ];

    const socialMediaData = [
        "/BrandContent/FAB_BrassLiquidDispenser.webp",
        "/BrandContent/FAB_Hendles.webp",
        "/BrandContent/FAB_Product2.webp",
        "/BrandContent/FAB_Product6.webp",
        "/BrandContent/GLISTONE_Bike.webp",
        "/BrandContent/JDCC_TeethWhitening2.webp",
        "/BrandContent/JKenterprise2.webp",
        "/BrandContent/CAPITAL_CURE_HealthInsurance.webp",
        "/BrandContent/CAPITAL_CURE_MutualFunds.webp",
        "/BrandContent/CAPITAL_CURE_MutualFunds3.webp",
        "/BrandContent/PatelWealth_SIP.webp",
        "/BrandContent/PatelWealth_SIP2.webp",
        "/BrandContent/Labh_Pancham_post.webp",
        "/BrandContent/TheBreakfastTime_GheePodiUpma.webp",
        "/BrandContent/TheBreakfastTime_Poha.webp",
    ];

    const logoData = [
        "/Assets/PiStraz_LOGOArtboard-1.webp",
        "/Assets/Logo_dark.webp",
    ];

    const renderContent = () => {
        if (activeTab === "Website") {
            return (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {websiteData.map((project, index) => (
                        <Card key={`website-${index}`} project={project} />
                    ))}
                </div>
            );
        }

        const data = activeTab === "Brand Content" ? socialMediaData : logoData;

        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-4">
                {data.map((image, index) => (
                    <ImageCard
                        key={`${activeTab}-${index}`}
                        image={image}
                        alt={`${activeTab} design project by Bhavya Kansara`}
                    />
                ))}
            </div>
        );
    };

    return (
        <section
            ref={sectionRef}
            id="portfolio"
            className="relative w-full px-6 md:px-12 lg:px-20 xl:px-32 bg-background text-text-light"
        >
            <SectionHeading SectionNumber="03" SectionTitle="My Portfolio" />

            {/* SEO CONTEXT (Invisible but VERY IMPORTANT) */}
            <p className="sr-only">
                Portfolio of Bhavya Kansara showcasing professional web development,
                e-commerce websites, brand design, social media creatives, and logo
                design projects. This work highlights expertise in React development,
                frontend engineering, UI design, and visual branding.
            </p>

            {/* Tabs */}
            <div className="flex justify-start border-b border-[#acacac2b] mb-8 overflow-x-auto">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        onClick={() => {
                            setActiveTab(tab);
                            setTimeout(() => {
                                sectionRef.current?.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                });
                            }, 0);
                        }}
                        className={`py-3 px-3 sm:px-6 text-basic sm:text-lg font-medium transition 
                        ${activeTab === tab
                                ? "border-b-2 border-accent text-accent"
                                : "text-text-light/60 hover:text-text-light"
                            }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {renderContent()}
        </section>
    );
};

export default WorkSection;